import { useEffect, useRef, useState } from 'react';
import { LIST_PREFERENCES_CHANGED } from './listPreferences';

// A yes/no read from the stored list settings (has this list a personal layout, so can it be reset?) that follows
// them as they change. Dragging a column divider saves on every pointer move, so re-rendering on each change event
// re-rendered the toolbar - and on the user Tickets tab the whole grid - dozens of times a second. The event now
// only stores the answer, and React skips the render when it is the same. The value returned is read afresh on
// each render, so it is right straight away when the view or tab that `read` depends on changes.
export const useListPreferenceFlag = (read: () => boolean): boolean => {
  const readRef = useRef(read);
  readRef.current = read;
  const [, setFlag] = useState(read);
  useEffect(() => {
    const onChanged = () => setFlag(readRef.current());
    window.addEventListener(LIST_PREFERENCES_CHANGED, onChanged);
    return () => window.removeEventListener(LIST_PREFERENCES_CHANGED, onChanged);
  }, []);
  return read();
};
